import React, { useState } from "react";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { Select } from "antd";
import useAdvancedFiltersConcentracaoColheita from "../hooks/useAdvancedFiltersConcentracaoColheita";
import useSafraPeriodo from "../hooks/useSafraPeriodo";
import { useFilters } from "features/filters/store";

interface ConcentracaoColheitaAdvancedFiltersProps {
  handleCloseModal: () => void;
}
export interface AdvancedFiltersProps {
  safraPeriodos?: string[];
}

const ConcentracaoColheitaAdvancedFilters = ({
  handleCloseModal,
}: ConcentracaoColheitaAdvancedFiltersProps) => {

  const { filters } = useFilters();

  const safraId = filters?.safra?.id ?? "";
  const ocupacoes = filters?.ocupacoes ?? [];
  const ocupacao = ocupacoes?.find(item => Number(item.codigo) === filters?.filtroConcentracaoColheita?.ocupacao);
  const ocupacaoId = ocupacao?.ocupacaoId ?? "";

  const { data } = useSafraPeriodo(ocupacaoId, safraId, filters?.tipoMapa);
  const items = data?.items ?? [];
  const options = items?.map(item => ({ value: item.id, label: item.nomeOriginal }));

  const {
    items: {
      filterSafraPeriodos,
    },
    onChange,
    clearFilters,
  } = useAdvancedFiltersConcentracaoColheita();

  const [advancedFilters, setAdvancedFilters] = useState<AdvancedFiltersProps>({
    safraPeriodos: filterSafraPeriodos,
  });

  const handleChangeSafraPeriodos = (props: string[]) => {
    setAdvancedFilters({
      ...advancedFilters,
      safraPeriodos: props,
    });
  };

  return (
    <>
      <Text
        fontSize="16px"
        color="green.600"
        fontWeight="bold"
        margin="20px 20px 10px"
      >
        {" "}
        Filtros Avançados
      </Text>
      <Box margin="8px 15px" padding={0}>
        <Text color="gray.700" fontSize="16px" marginRight="5px" marginBottom="15px">
          Safra Período
        </Text>
        <Select
          allowClear
          size="large"
          mode="multiple"
          options={options}
          placeholder="Safra Período"
          onChange={handleChangeSafraPeriodos}
          style={{ width: "100%" }}
          maxTagCount={0}
          maxTagPlaceholder={() => `Safra Períodos (${advancedFilters?.safraPeriodos?.length || 0})`}
        />
      </Box>
      <Flex justifyContent="flex-end" padding="10px 20px">
        <Button
          background="transparent"
          onClick={() => clearFilters(setAdvancedFilters)}
          marginRight="10px"
        >
          <Text color="gray.600">Limpar filtros</Text>
        </Button>

        <Button
          background="green.600"
          onClick={() => onChange(advancedFilters, handleCloseModal)}
        >
          <Text color="white">Aplicar Filtros</Text>
        </Button>
      </Flex>
    </>
  );
};

export default ConcentracaoColheitaAdvancedFilters;
